// @ts-nocheck
export default {
    getterWorkerAllocatedCancelPenaltyGroupList: (state) => state.workerAllocatedCancelPenaltyGroupList.map((it) => ({
        ...it,
    })),
    // 추후 값 맵핑을 위해 필요함.
    getterWorkerAllocatedCancelPenaltyGroupOptionList: (state) => state
        .workerAllocatedCancelPenaltyGroupOptionList.map((it) => ({
        ...it,
    })),
    getterSelectedPenaltyGroupId: (state) => state.selectedPenaltyGroup?.id,
    getterSelectedPenaltyGroupName: (state) => state.selectedPenaltyGroup?.name,
};
